Auth = require 'app/scripts/db/auth'
Hearsay = require 'hearsay'
Promise = require 'bluebird'
assert = require 'app/scripts/lib/assert'
config = require '@trello/config'

errorSignal = new Hearsay.Emitter()
errorSignal.use()

class ErrorInfo
  constructor: (@error, @url = document.location.href, @line = 0, @col = 0) ->
    assert @error?

window.onerror = (msg, url, line, col, error) ->
  error ?= new Error(msg)
  errorSignal.send new ErrorInfo(error, url, line, col)

Promise.onPossiblyUnhandledRejection (error) ->
  # Make sure this lands in the browser console if the
  # member is not on the stable channel or are running locally
  channels = Auth.me()?.get('channels')
  shouldPrintRejection = channels?.active != 'stable' ||
    channels?.dev || config.clientVersion == 'dev-0'

  if shouldPrintRejection
    console?.warn("Possibly Unhandled Rejection:", error.message)
    console?.error(error.stack)

  errorSignal.send new ErrorInfo(error)

module.exports = errorSignal
